import { createContext, useContext } from "react";
import type SearchIndex from "../components/sodoSearch/search-index";
import type { DispatchFn, GhostPost, GhostAuthor, GhostTag } from "../types";

export interface AppContextType {
  page: string;
  posts: GhostPost[];
  authors: GhostAuthor[];
  tags: GhostTag[];
  action: string;
  lastPage: string;
  pageData: Record<string, unknown>;
  showPopup: boolean;
  adminUrl: string;
  stylesUrl?: string;
  brandColor?: string;
  searchIndex: SearchIndex | null;
  indexComplete: boolean;
  searchValue: string;
  onAction: () => void;
  dispatch: DispatchFn;
}

const AppContext = createContext<AppContextType>({
  posts: [],
  authors: [],
  tags: [],
  action: "",
  lastPage: "",
  page: "",
  pageData: {},
  showPopup: false,
  adminUrl: "",
  searchIndex: null,
  indexComplete: false,
  searchValue: "",
  onAction: () => {},
  dispatch: () => {},
});

export const useAppContext = () => useContext(AppContext);

export default AppContext;
